module.exports = __webpack_public_path__ + "img/python.7ee491c3.png";